import RecentActivity from './RecentActivityContainer'

export default RecentActivity